type EVENT = 'event';
type PAGE = 'page';

export const EVENT: EVENT = 'event';
export const PAGE: PAGE = 'page';
export const WINDOW_KEY = '__tpClientQueue';

export type ConsumeTypes = (EVENT | PAGE);

type TrackNow = boolean;
export type TransportFormat = [ConsumeTypes, Event, TrackNow];

type HookHandler = (s: string, p: string) => void;

declare global {
    interface Window {
        __tpClientHook: HookHandler[];
        __tpClientQueue: any;
        tpDataLayer: [];
    }
}

export interface Event {
    referrer?: string;
    viewUuid?: string;
    url?: string;
    applicationName?: string;

    properties?: Properties;

    type?: string;
    name?: string;
    labels?: string[];

}

type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;

export interface Properties {
    [s: string]: any;
}
